<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">
        <nav class="footer-nav">
          <ul>
            <li>
              <a
                :href="'https://sendsquared.com/about'"
                target="_blank"
                rel="noopener"
                >About SendSquared</a
              >
            </li>
            <li>
              <a
                :href="'https://sendsquared.com/legal/privacy-policy'"
                target="_blank"
                rel="noopener"
                >Privacy</a
              >
            </li>
            <li>
              <a
                :href="'https://sendsquared.com/legal/terms-of-use'"
                target="_blank"
                rel="noopener"
                >Terms</a
              >
            </li>
          </ul>
        </nav>
        <div class="credits ml-auto">
          <div class="copyright">
            &copy; Coded with
            <i class="fa fa-heart heart"></i> by
            <a :href="'https://sendsquared.com'" target="_blank" rel="noopener"
              >SendSquared</a
            >.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
